module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel text-lighter"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', [_vm._v("地址：中国·浙江杭州拱墅区祥园路45号\n          ")]), _c('p', {
    staticStyle: {
      "margin-left": "42px"
    }
  }, [_vm._v("北部软件园盘石互联网广告大厦")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("传真：+86-571-81951158")]), _vm._v(" "), _c('p', [_vm._v("邮编：310015")])]), _vm._v(" "), _c('div', {
    staticClass: "panel text-lighter"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("合作咨询")]), _vm._v(" "), _c('p', [_vm._v("媒介合作：Ruby  2294631503（QQ）0571-56079459（固话）")]), _vm._v(" "), _c('p', [_vm._v("全国热线：400-100-1110")]), _vm._v(" "), _c('p', [_vm._v("渠道加盟：0571-56926030")])]), _vm._v(" "), _c('div', {
    staticClass: "Qcode pull-right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "/static/footer/qcode2.jpeg",
      "alt": "panshiQcode"
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "/static/footer/qcode1.jpeg",
      "alt": "panshiQcode"
    }
  }), _vm._v(" "), _c('span', [_vm._v("官方微博")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix text-lighter"
  }, [_c('div', {
    staticClass: "foot-nav"
  }, [_c('a', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.adyun.com"
    }
  }, [_vm._v("盘石首页")])]), _vm._v(" "), _c('div', {
    staticClass: "foot-nav"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.adyunwm.com"
    }
  }, [_vm._v("盘石网站联盟推广")])]), _vm._v(" "), _c('div', {
    staticClass: "foot-nav"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.adyun.com/mobile.html"
    }
  }, [_vm._v("盘石中文移动联盟推广")])]), _vm._v(" "), _c('div', {
    staticClass: "foot-nav"
  }, [_c('a', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "target": "_blank",
      "href": "http://tiyan.adyun.com"
    }
  }, [_vm._v("网盟体验中心")])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('img', {
    attrs: {
      "src": "/static/footer/footer-logo.png",
      "alt": "panshiLogo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-small text-lighter pull-right"
  }, [_vm._v("\n        Copyright©2004-2016 浙江盘石信息技术股份有限公司 All Rights Reserved 浙B2-20090026\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d65af40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/footer/footer.vue
// module id = 442
// module chunks = 2